var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "对账单详情",
        width: "960px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.detailLoading,
              expression: "detailLoading",
            },
          ],
          staticClass: "detail-container",
        },
        [
          _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "section-title" }, [_vm._v("基础信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "info-grid" }, [
              _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("对账单号")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.detail.statementNo || "-")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("商家名称")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.detail.merchantName || "-")),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "info-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("商家类型")]),
                  _vm._v(" "),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.merchantTypeTagType(_vm.detail.merchantType),
                        size: "small",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.merchantTypeText(_vm.detail.merchantType))
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("生成时间")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.detail.createTime || "-")),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "info-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("对账状态")]),
                  _vm._v(" "),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.reconciliationStatusTagType(
                          _vm.detail.reconciliationStatus
                        ),
                        size: "small",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.reconciliationStatusText(
                            _vm.detail.reconciliationStatus
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "info-item" },
                [
                  _c("span", { staticClass: "label" }, [_vm._v("打款状态")]),
                  _vm._v(" "),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.paymentStatusTagType(
                          _vm.detail.paymentStatus
                        ),
                        size: "small",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.paymentStatusText(_vm.detail.paymentStatus))
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("账单周期")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.detail.periodDesc || "-")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("创建人")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.detail.createUserName || "-")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item info-item-wide" }, [
                _c("span", { staticClass: "label" }, [_vm._v("对账备注")]),
                _vm._v(" "),
                _c("span", { staticClass: "value remark-value" }, [
                  _vm.detail.reconciliationRemark
                    ? _c(
                        "span",
                        {
                          staticClass: "remark-text",
                          attrs: { title: _vm.detail.reconciliationRemark },
                        },
                        [_vm._v(_vm._s(_vm.detail.reconciliationRemark))]
                      )
                    : _c("span", { staticClass: "remark-empty" }, [
                        _vm._v("-"),
                      ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item info-item-wide" }, [
                _c("span", { staticClass: "label" }, [_vm._v("财务备注")]),
                _vm._v(" "),
                _c("span", { staticClass: "value remark-value" }, [
                  _vm.detail.financialRemark
                    ? _c(
                        "span",
                        {
                          staticClass: "remark-text",
                          attrs: { title: _vm.detail.financialRemark },
                        },
                        [_vm._v(_vm._s(_vm.detail.financialRemark))]
                      )
                    : _c("span", { staticClass: "remark-empty" }, [
                        _vm._v("-"),
                      ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.merchantFileList.length
                ? _c("div", { staticClass: "info-item info-item-wide" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("商家订单数据"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value" },
                      _vm._l(_vm.merchantFileList, function (file) {
                        return _c(
                          "div",
                          { key: file.url, staticClass: "merchant-file-item" },
                          [
                            _c(
                              "el-link",
                              {
                                staticClass: "download-link",
                                attrs: {
                                  type: "primary",
                                  href: file.url,
                                  target: "_blank",
                                  underline: false,
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-download" }),
                                _vm._v(" 下载文件\n              "),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "file-name" }, [
                              _vm._v(_vm._s(file.name)),
                            ]),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("span", { staticClass: "label" }, [_vm._v("打款主体公司")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.detail.companyName || "-")),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section transaction-section" }, [
            _c("div", { staticClass: "section-title" }, [_vm._v("交易信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "trans-grid" }, [
              _c("div", { staticClass: "trans-item" }, [
                _c("div", { staticClass: "trans-label" }, [_vm._v("订单金额")]),
                _vm._v(" "),
                _c("div", { staticClass: "trans-value" }, [
                  _vm._v(
                    "+￥" +
                      _vm._s(_vm.formatAmount(_vm.summaryFromList.orderAmount))
                  ),
                ]),
                _vm._v(" "),
                _vm.hasAmount(_vm.summaryFromList.freightAmount)
                  ? _c("div", { staticClass: "trans-extra" }, [
                      _vm._v(
                        "含运费：￥" +
                          _vm._s(
                            _vm.formatAmount(_vm.summaryFromList.freightAmount)
                          )
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAmount(_vm.summaryFromList.packingFeeAmount)
                  ? _c("div", { staticClass: "trans-extra" }, [
                      _vm._v(
                        "含打包费：￥" +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.summaryFromList.packingFeeAmount
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "trans-item" }, [
                _c("div", { staticClass: "trans-label" }, [
                  _vm._v("成交结算金额"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "trans-value income" }, [
                  _vm._v(
                    "+￥" +
                      _vm._s(
                        _vm.formatAmount(_vm.summaryFromList.settlementAmount)
                      )
                  ),
                ]),
                _vm._v(" "),
                _vm.hasAmount(_vm.summaryFromList.freightAmount)
                  ? _c("div", { staticClass: "trans-extra" }, [
                      _vm._v(
                        "含运费：￥" +
                          _vm._s(
                            _vm.formatAmount(_vm.summaryFromList.freightAmount)
                          )
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAmount(_vm.summaryFromList.packingFeeAmount)
                  ? _c("div", { staticClass: "trans-extra" }, [
                      _vm._v(
                        "含打包费：￥" +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.summaryFromList.packingFeeAmount
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "trans-item" }, [
                _c("div", { staticClass: "trans-label" }, [_vm._v("订单数量")]),
                _vm._v(" "),
                _c("div", { staticClass: "trans-value" }, [
                  _vm._v(_vm._s(_vm.summaryFromList.orderCount || 0)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "trans-item trans-item-highlight" }, [
                _c("div", { staticClass: "trans-label" }, [
                  _vm._v("实际结算金额"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "trans-value highlight" }, [
                  _vm._v(
                    "+￥" +
                      _vm._s(
                        _vm.formatActualSettlementAmount(_vm.summaryFromList)
                      )
                  ),
                ]),
                _vm._v(" "),
                _vm.hasAmount(_vm.summaryFromList.actualSettlementFreightAmount)
                  ? _c("div", { staticClass: "trans-extra" }, [
                      _vm._v(
                        "含运费：￥" +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.summaryFromList.actualSettlementFreightAmount
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasAmount(
                  _vm.summaryFromList.actualSettlementPackingFeeAmount
                )
                  ? _c("div", { staticClass: "trans-extra" }, [
                      _vm._v(
                        "含打包费：￥" +
                          _vm._s(
                            _vm.formatAmount(
                              _vm.summaryFromList
                                .actualSettlementPackingFeeAmount
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("关 闭"),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }